import React from 'react';
import Modal from 'react-modal';

const formatMetric = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const ActivePartnerUsersModal = ({ isOpen, onClose, users = [], total = 0 }) => {
  const activeUsers = users || [];

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Active Partner Users"
      className="leader-con-modal partner-active-users-modal"
      overlayClassName="leader-con-modal-overlay"
    >
      <div className="leader-con-modal-header">
        <div>
          <h2 className="leader-con-modal-title">Active Partner Users</h2>
          <p className="leader-con-modal-subtitle">Users with activity in the selected period</p>
        </div>
        <button type="button" className="leader-con-modal-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      <div className="partner-active-users-summary">
        <span className="partner-active-users-count">{formatMetric(total)}</span>
        <span className="partner-active-users-label">Total active users</span>
      </div>

      <div className="leader-con-modal-content partner-active-users-content">
        {activeUsers.length > 0 ? (
          <div className="partner-active-users-table-wrap">
            <table className="partner-active-users-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Company</th>
                  <th>Region</th>
                  <th>Demo Runs</th>
                  <th>Bookings</th>
                </tr>
              </thead>
              <tbody>
                {activeUsers.map((user, index) => (
                  <tr key={user.userId || user.email || `${user.name}-${index}`}>
                    <td>
                      <span className="partner-active-user-name">{user.name || 'Unknown'}</span>
                    </td>
                    <td>{user.email || '-'}</td>
                    <td>{user.company || '-'}</td>
                    <td>
                      <span className="lead-company-region-badge">{user.region || '-'}</span>
                    </td>
                    <td>{formatMetric(user.totalRuns)}</td>
                    <td>{formatMetric(user.totalBookings)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="leader-con-modal-no-data">
            No active partner users found for the selected filter.
          </p>
        )}
      </div>
    </Modal>
  );
};

export default ActivePartnerUsersModal;
